import type {
  Pinia,
} from "pinia";

import {
  useThemeStore,
} from "~/stores/theme";

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = nuxtApp.$pinia as Pinia | undefined;
  if (!pinia) {
    return;
  }
  const themeStore = useThemeStore(pinia);
  themeStore.initialize();
});
